<template>
    <ImageBoxTemplate :img="hydroImg">
        <div class="d-flex vertical-center justify-center w-50">
            <div class="btn-primary m-20px plr-50px" @click="$emit('update:modelValue', 'Oui')">Oui</div>
            <div class="btn-primary m-20px plr-50px" @click="$emit('update:modelValue', 'Non')">Non</div>
        </div>
      </ImageBoxTemplate>
</template>
<script>
import ImageBoxTemplate from '@/components/ImageBoxTemplate'
export default {
    data(){
        return {
            hydroImg:require('@/assets/images/hydro.png')
        }
    },
    components:{
        ImageBoxTemplate
    }
}
</script>
 <style scoped>

@media screen and (max-width: 1300px) {
  .mobile-w-100{
    width:100%;
  }
  .mobile-w-100>img{
    width:100%;
  }
  .d-flex{
    flex-wrap: wrap;
  }
}
</style>